<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i class="fas fa-star-half-alt"></i> Información sesión interactiva
        </h4>
      </template>
      <template v-slot:headerAction>
        <b-button class="mt-3 ml-2" variant="primary" @click="goBack">{{
          $t("generic.btnBack")
        }}
        </b-button>
        <b-button class="mt-3 ml-2" variant="danger" @click="finish">
          Cerrar
        </b-button>
        <b-button class="mt-3 ml-2" v-if="interactive.status === 'OPEN'" variant="success" @click="updateInteractive">
          Actualizar
        </b-button>
        <b-button class="mt-3 ml-2" variant="success" @click="goToChat">
          Entrar
        </b-button>
      </template>
      <b-card-text>
        <b-container>
          <b-card-title>Datos</b-card-title>
          <b-row>
            <!-- Campos de información básica -->
            <b-col md="6">
              <b-form-group label="Url usuario interactivo" label-for="input-id">
                <strong>{{url}}public/interactive?interactiveId={{ interactiveId}}</strong>
              </b-form-group>
              <b-form-group label="ID" label-for="input-id">
                <b-form-input id="input-id" v-model="interactive.id" readonly></b-form-input>
              </b-form-group>
              <b-form-group label="Nombre" label-for="input-name">
                <b-form-input id="input-name" v-model="interactive.name"></b-form-input>
              </b-form-group>
              <b-form-group label="Estado" label-for="input-status">
                <b-form-input id="input-status" v-model="interactive.status" readonly></b-form-input>
              </b-form-group>
              <b-form-group label="Máximo de Participantes" label-for="input-max-participants">
                <b-form-input id="input-max-participants" v-model="interactive.maxParticipants" readonly></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Url pago usuario interactivo" label-for="input-id">
                <strong>{{url}}public/interactive/payment?interactiveId={{ interactiveId}}</strong>
              </b-form-group>
              <b-form-group label="Inicio" label-for="input-started-at">
                <b-form-input id="input-started-at" v-model="interactive.startedAt" readonly></b-form-input>
              </b-form-group>
              <b-form-group label="Comentarios" label-for="input-comments">
                <b-form-input id="input-comments" v-model="interactive.comments"></b-form-input>
              </b-form-group>
              <b-form-group label="Iniciación" label-for="input-init-at">
                <b-form-input id="input-init-at" v-model="interactive.initAt" readonly></b-form-input>
              </b-form-group>
              <b-form-group label="Finalización" label-for="input-finish-at">
                <b-form-input id="input-finish-at" v-model="interactive.finishAt" readonly></b-form-input>
              </b-form-group>
              <b-form-group label="Minutos Totales" label-for="input-total-minutes">
                <b-form-input id="input-total-minutes" v-model="interactive.totalMinutes" readonly></b-form-input>
              </b-form-group>
              <b-form-group label="Precio" label-for="input-price-cents">
                <b-form-input id="input-price-cents" v-model="interactive.priceCents" readonly></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-card-title>Usuarios interactivos</b-card-title>
          <!-- Tabla de usuarios interactivos -->
          <b-table striped hover :items="interactiveUsers" class="mt-3" :fields="tableFields">
            <template #cell(id)="data">
              {{ data.item.id }}
            </template>
            <template #cell(email)="data">
              {{ data.item.email }}
            </template>
            <template #cell(banned)="data">
              <b-badge variant="danger" v-if="data.item.banned">Baneado</b-badge>
              <b-badge variant="success" v-else>No Baneado</b-badge>
            </template>
            <template #cell(code)="data">
              {{ data.item.code || 'N/A' }}
            </template>
            <template #cell(payment)="data">
              <b-badge variant="success" v-if="data.item.payment && data.item.payment.status === 'SUCCESS'">Pagado ({{ data.item.payment.mode }})</b-badge>
              <b-badge variant="danger" v-else>No pagado</b-badge>
            </template>
            <template #cell(action)="data">
              <b-button variant="danger" @click="deleteUser(data.item.id)">
                Borrar
              </b-button>
              <b-button variant="danger" @click="bannedUser(data.item.id)" v-if="!data.item.banned">
                Banear
              </b-button>
              <b-button variant="success" @click="desbannedUser(data.item.id)" v-else>
                Des-Banear
              </b-button>
            </template>
          </b-table>
          <b-form @submit.prevent="addInteractiveUser">
            <b-button type="submit" variant="primary">Añadir Usuario</b-button>
          </b-form>
        </b-container>
      </b-card-text>
    </iq-card>
    <b-modal id="modal-interactive-user" centered @ok="interactiveUserSave">
      <template #modal-cancel>{{
        $t("public.components.schedule.Schedule.modalBankAccount.btnCancel")
      }}
      </template>
      <template #modal-ok> {{ $t("public.components.schedule.Schedule.modalCreate.btnCreate") }}
      </template>
      <template #modal-title>
        Añadir usuario interactivo
      </template>
      <b-form-group label="Email: *" label-for="email">
        <b-form-input id="email" v-model="interactiveUser.email" type="text" v-bind:class="{
          'text-danger': isFormEmailErrors,
          'is-invalid': isFormEmailErrors,
        }" @blur="checkEmail(interactiveUser.email)"></b-form-input>
        <ul v-if="isFormEmailErrors">
          <li v-for="(error, index) in validatorStep1.getErrors(
            'modal-interactive-user-email'
          )" v-bind:key="index" class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>

      <b-form-group label-for="email">
        <template slot="label">Accion: *
        </template>
        <b-select id="action" v-model="interactiveUser.action" :options="actionsSelect" class="form-control"></b-select>
      </b-form-group>
    </b-modal>
  </b-container>
</template>
<script>
import routes from "../../../../router/index";
import { xray } from "../../../../config/pluginInit";

import validator from "vue-m-validator";


import interactiveService from "../../../../services/interactive";

import utilsService from "../../../../services/utils";

export default {
  name: "InteractiveInfo",
  mounted() {
    xray.index();
    this.getInteractive(this.interactiveId);
    this.getAllInteractiveUser(this.interactiveId);
    utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_RATINGS", info: "" });
  },
  computed: {
    isFormEmailErrors() {
      if (!this.disabled) {
        const RULE_2_REGEXP = new RegExp(
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
        );
        if (RULE_2_REGEXP.test(this.email)) {
          this.getCheckEmail(this.email);
        }
        let errors = this.validatorStep1.getErrors("email");
        return errors && errors.length > 0;
      }
    }
  },
  methods: {
    async deleteUser(interactiveUserId) {
      let self = this;
      this.$awn.asyncBlock(
        interactiveService.deleteUser(this.interactiveId, interactiveUserId),
        (response) => {
          if (response) {
            self.getAllInteractiveUser(self.interactiveId);
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "interactiveService.init",
            module: "view-pages-professional-rating",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              obj: obj
            })
          });
        },
        " "
      );
    },
    async desbannedUser(interactiveUserId) {
      let self = this;
      this.$awn.asyncBlock(
        interactiveService.desbannedUser(this.interactiveId, interactiveUserId),
        (response) => {
          if (response) {
            self.getAllInteractiveUser(self.interactiveId);
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "interactiveService.init",
            module: "view-pages-professional-rating",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              obj: obj
            })
          });
        },
        " "
      );
    },
    async bannedUser(interactiveUserId) {
      let self = this;
      this.$awn.asyncBlock(
        interactiveService.bannedUser(this.interactiveId, interactiveUserId),
        (response) => {
          if (response) {
            self.getAllInteractiveUser(self.interactiveId);
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "interactiveService.init",
            module: "view-pages-professional-rating",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              obj: obj
            })
          });
        },
        " "
      );
    },
    async finish() {
      let self = this;
      this.$awn.asyncBlock(
        interactiveService.finish(this.interactiveId),
        (response) => {
          if (response) {
            self.goBack();
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "interactiveService.init",
            module: "view-pages-professional-rating",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              obj: obj
            })
          });
        },
        " "
      );
    },
    async checkEmail(_email) {
      const EMAIL = _email;
      const RULE_1 = {
        expression: !EMAIL || EMAIL === "",
        name: "email",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Contact.Contacts.errors.erEmail1"
        ),
      };
      /* eslint-disable-next-line */
      const RULE_2_REGEXP = new RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
      );
      const RULE_2 = {
        expression: !RULE_2_REGEXP.test(EMAIL),
        name: "email",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Contact.Contacts.errors.erEmail2"
        ),
      };
      this.validatorStep1.addRule(RULE_1).addRule(RULE_2);
      this.notFirst();
    },
    async interactiveUserSave() {
      let self = this;

      this.$awn.asyncBlock(
        interactiveService.addInteractiveUser(this.interactiveId, this.interactiveUser),
        (response) => {
          self.$bvModal.hide("modal-interactive-user");
          self.getAllInteractiveUser(this.interactiveId);
          self.$notify({
            group: "notificacions",
            title: "Accion correcta",
            text: "Se a creado el usuario interactivo",
            type: "success",
          });
        },
        (error) => {
   
            self.$swal(
              "Error",
              "Email ya esta en uso en esta sesion interactiva"
            );
        }
      );
    },
    async addInteractiveUser() {
      this.interactiveUser = { email: "", action: "SEND_NEW_CODE" };
      this.validatorStep1.errors = [];
      this.$bvModal.show("modal-interactive-user");
    },
    async goToChat() {

      routes.push({
        name: "auth.interactive.chat",
        query: { interactiveId: this.interactiveId },
      });

    },
    async updateInteractive() {
      let self = this;
      let data = {
        name: this.interactive.name,
        comments: this.interactive.comments
      }
      this.$awn.asyncBlock(
        interactiveService.update(this.interactiveId, data),
        (response) => {
          if (response) {
          
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "interactiveService.init",
            module: "view-pages-professional-rating",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              obj: obj
            })
          });
        },
        " "
      );
    },
    async goBack() {
      this.$router.go(-1);
    },
    async getInteractive(id) {
      let self = this;
      this.$awn.asyncBlock(
        interactiveService.get(id),
        (response) => {
          if (response) {
            self.interactive = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "ratingService.create",
            module: "view-pages-professional-rating",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              obj: obj
            })
          });
        },
        " "
      );
    },
    async getAllInteractiveUser(id) {
      let self = this;
      this.$awn.asyncBlock(
        interactiveService.getAllInteractiveUser(id),
        (response) => {
          if (response) {
            self.interactiveUsers = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "ratingService.create",
            module: "view-pages-professional-rating",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              obj: obj
            })
          });
        },
        " "
      );
    },
  },

  data() {
    return {
      url: process.env.VUE_APP_BASE_URL_WEBAPP,
      validatorStep1: validator,
      actionsSelect: [
        { value: 'SEND_NEW_CODE', text: 'Envio de código al email' },
        { value: 'SEND_PAYMENT', text: 'Envio enlace pago' }
      ],
      tableFields: [
      { key: 'id', label: 'ID' },
      { key: 'email', label: 'Email' },
      { key: 'banned', label: 'Baneado' },
      { key: 'code', label: 'Código' },
      { key: 'payment', label: 'Pago' },
      { key: 'action', label: '' },
      ],
      interactiveUser: { email: "", action: "SEND_NEW_CODE" },
      interactiveId: this.$route.query.interactiveId,
      interactive: [],
      interactiveUsers: []
    };
  },
};
</script>
